.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  height: 100%;
  justify-content: center;
}

.modal-container {
  background: var(--color-grey-8-5);
  border: 0.1rem solid var(--color-grey-7-5);
  border-radius: 1.2rem;
  max-height: 68rem;
  min-width: 44rem;
  max-width: 44rem;
  width: 100%;
  padding: 1rem;
}

.header {
  font-size: 2rem;
  line-height: 2.4rem;
  font-weight: 700;
  color: var(--step-title-color);
}

.version-item-wrapper {
  padding: 0.8rem 0;
  border-bottom: 0.1rem solid var(--color-grey-7-5);

  :last-child {
    border-bottom: none;
  }
}

.version-title {
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.9rem;
  display: flex;
  align-items: center;
  color: var(--color-grey-5);
}

.version {
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
  display: flex;
  align-items: center;
  color: var(--color-grey-6);
}

.version-item {
  padding: 0.8rem;
  border-radius: 0.6rem;
  cursor: pointer;

  &:hover {
    background: var(--color-grey-8);

    .version-title {
      color: var(--white-default);
    }

    .version {
      color: var(--color-grey-3);
    }
  }
}
